import { defineMessages } from '../define';

export default defineMessages({
  'ls.Нет': { ru: 'Нет', en: 'None' },
  'ls.Мягко': { ru: 'Мягко', en: 'Gentle' },
  'ls.Тихо': { ru: 'Тихо', en: 'Quiet' },
  'ls.Средне': { ru: 'Средне', en: 'Medium' },
  'ls.Громко': { ru: 'Громко', en: 'Loud' },
  'ls.Сильнее': { ru: 'Сильнее', en: 'Stronger' },
  'ls.Оригинал': { ru: 'Оригинал', en: 'Original' },
  'ls.Омела': { ru: 'Омела', en: 'Mistletoe' },
  'ls.Глубокий циан': { ru: 'Глубокий циан', en: 'Deep cyan' },
  'ls.Меркнущий свет': { ru: 'Меркнущий свет', en: 'Fading light' },
  'ls.Мода Y2K': { ru: 'Мода Y2K', en: 'Y2K fashion' },
  'ls.Кодак 500T': { ru: 'Кодак 500T', en: 'Kodak 500T' },
  'ls.Тёплый': { ru: 'Тёплый', en: 'Warm' },
  'ls.Прохладный': { ru: 'Прохладный', en: 'Cool' },
  'ls.Мягкий': { ru: 'Мягкий', en: 'Soft' },
  'ls.Ч/б': { ru: 'Ч/б', en: 'B&W' },
  'ls.Линия': { ru: 'Линия', en: 'Line' },
  'ls.Лента': { ru: 'Лента', en: 'Ribbon' },
  'ls.Хайлайт': { ru: 'Хайлайт', en: 'Highlight' },
  'ls.Жидкий хайлайт': { ru: 'Жидкий хайлайт', en: 'Liquid highlight' },
  'ls.Рамка': { ru: 'Рамка', en: 'Frame' },
  'ls.Классика': { ru: 'Классика', en: 'Classic' },
  'ls.Скобки': { ru: 'Скобки', en: 'Brackets' },
  'ls.Волна': { ru: 'Волна', en: 'Wave' },
  'ls.Пара': { ru: 'Пара', en: 'Pair' },
  'ls.Белая': { ru: 'Белая', en: 'White' },
  'ls.Черная': { ru: 'Черная', en: 'Black' },
  'ls.Мелкий': { ru: 'Мелкий', en: 'Small' },
  'ls.Средний': { ru: 'Средний', en: 'Medium' },
  'ls.Большой': { ru: 'Большой', en: 'Large' },
  'ls.Обычный': { ru: 'Обычный', en: 'Normal' },
  'ls.Капсом': { ru: 'Капсом', en: 'All caps' },
  'ls.Без субтитров': { ru: 'Без субтитров', en: 'No subtitles' },
  'ls.Акцент': { ru: 'Акцент', en: 'Accent' },
  'ls.Минимал': { ru: 'Минимал', en: 'Minimal' },
  'ls.Плашка': { ru: 'Плашка', en: 'Box' },
  'ls.Лимон': { ru: 'Лимон', en: 'Lemon' },
  'ls.Янтарь': { ru: 'Янтарь', en: 'Amber' },
  'ls.Апельсин': { ru: 'Апельсин', en: 'Orange' },
  'ls.Коралл': { ru: 'Коралл', en: 'Coral' },
  'ls.Розовый': { ru: 'Розовый', en: 'Pink' },
  'ls.Фиолет': { ru: 'Фиолет', en: 'Violet' },
  'ls.Лазурь': { ru: 'Лазурь', en: 'Azure' },
  'ls.Бирюза': { ru: 'Бирюза', en: 'Turquoise' },
  'ls.Лайм': { ru: 'Лайм', en: 'Lime' },
  'ls.Мята': { ru: 'Мята', en: 'Mint' },
  'ls.Без перехода': { ru: 'Без перехода', en: 'No transition' },
  'ls.Затемнение': { ru: 'Затемнение', en: 'Dip to black' },
  'ls.Вспышка': { ru: 'Вспышка', en: 'Flash' },
});
